import { useState } from 'react';
import { cn } from '@/lib/utils';

// molecule — DWR class card per la griglia di scelta classe. Image art (4/5)
// + nome Cinzel uppercase + meta italic. aria-pressed con badge "Scelta"
// (pseudo content via after:) + outline ink. Pattern .class-card mockup
// (styles.css righe 312-394).
// near-duplicate of future <Card variant>: emergerà quando in PR 6/7 si toccano
// move-card / spell-card / summary-card (composition principles §3.1). Per ora
// molecule dedicato (12 istanze nel solo SectionClass di PR 4).

interface ClassCardProps {
  classId: string;
  name: string;
  tagline?: string;
  selected?: boolean;
  onClick: () => void;
  className?: string;
}

export function ClassCard({
  classId,
  name,
  tagline,
  selected = false,
  onClick,
  className,
}: ClassCardProps) {
  const [imgError, setImgError] = useState(false);

  return (
    <button
      type="button"
      aria-pressed={selected}
      onClick={onClick}
      className={cn(
        'bg-paper-bright border-rule relative flex flex-col overflow-hidden border text-left transition-[transform,box-shadow,border-color] duration-150',
        'hover:border-ink hover:-translate-y-0.5 hover:shadow-[0_1px_0_rgba(24,19,13,0.08),0_8px_24px_-12px_rgba(24,19,13,0.18)]',
        'aria-pressed:border-ink aria-pressed:outline-ink aria-pressed:outline-2 aria-pressed:-outline-offset-[1px]',
        'aria-pressed:after:content-["Scelta"] aria-pressed:after:bg-ink aria-pressed:after:text-paper-bright aria-pressed:after:font-display aria-pressed:after:absolute aria-pressed:after:top-2 aria-pressed:after:right-2 aria-pressed:after:z-[2] aria-pressed:after:px-2 aria-pressed:after:py-[0.25em] aria-pressed:after:text-[0.62rem] aria-pressed:after:tracking-[0.1em] aria-pressed:after:uppercase',
        className,
      )}
    >
      <div className="bg-paper-bright relative grid aspect-[4/5] place-items-center overflow-hidden">
        {imgError ? (
          <ClassArtPlaceholder name={name} />
        ) : (
          <img
            src={`/classes/${classId}.png`}
            alt={name}
            loading="lazy"
            decoding="async"
            onError={() => setImgError(true)}
            className="h-full w-full object-contain p-[0.4rem]"
          />
        )}
      </div>
      <div className="border-rule font-display border-t px-[0.85rem] pt-[0.75rem] pb-[0.4rem] text-[1rem] font-bold tracking-[0.08em] uppercase">
        {name}
      </div>
      {tagline ? (
        <div className="text-ink-soft px-[0.85rem] pb-[0.75rem] text-[0.82rem] leading-[1.35] italic">
          {tagline}
        </div>
      ) : null}
    </button>
  );
}

function ClassArtPlaceholder({ name }: { name: string }) {
  return (
    <div className="font-display text-ink p-2 text-center text-[1.4rem] tracking-[0.06em] uppercase">
      Il {name}
    </div>
  );
}
